import { YesNoEmpty } from '@interfaces/models';
import { MultiAccountState as _MultiAccountState } from '@interfaces/state';
import { Action, createReducer, on } from '@ngrx/store';
import { UpdateIsCrewOnMultiTransactionFlow } from '@store/actions';

export interface MultiAccountState extends _MultiAccountState {}
export const initialState: MultiAccountState = {
  isCrewOnMultiTransactionFlow: YesNoEmpty.EMPTY,
};

const multiAccountReducer = createReducer(
  initialState,
  on(UpdateIsCrewOnMultiTransactionFlow, (state, { payload }) => ({
    ...state,
    isCrewOnMultiTransactionFlow: payload,
  })),
);

export function reducer(state: MultiAccountState | undefined, action: Action) {
  return multiAccountReducer(state, action);
}

export const getIsCrewOnMultiTransactionFlow = (state: MultiAccountState) =>
  state.isCrewOnMultiTransactionFlow;
